<div class="ui checkbox">
  <input
      #inputEl
      (blur)="onBlur()"
      id="{{ 'question-input-' + question.id }}"
      type="checkbox" [formControl]="myFormControl" [attr.disabled]="disabled"
      [attr.tabindex]="tabIndex">
  <label></label>
</div>
